import React from 'react';

interface MPPageTitleProps {
  children: React.ReactNode;
  subtitle?: string;
}

const MPPageTitle: React.FC<MPPageTitleProps> = ({ children, subtitle }) => (
  <div className="flex flex-col gap-0.5">
    <h2
      className="text-2xl font-bold tracking-tight"
      style={{ color: 'var(--strong-color)' }}
    >
      {children}
    </h2>
    {subtitle && (
      <p className="text-sm opacity-50" style={{ color: 'var(--text-color)' }}>
        {subtitle}
      </p>
    )}
  </div>
);

export default MPPageTitle;
